import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/Index";

interface Props {
  approvedComments: number;
  allComments: number;
}

export const TableRowCommentsCounts: React.FC<Props> = ({
  approvedComments,
  allComments,
}) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);

  const coloredBarPercentage = (
    approvedComments: number,
    allComments: number
  ): string => {
    if (allComments === 0) {
      return "0%";
    }
    const percentage = Math.floor((approvedComments / allComments) * 100);
    return `${percentage}%`;
  };

  return (
    <>
      <Typography variant="body1">
        {`${approvedComments}/${allComments}`}
      </Typography>
      <Box
        sx={{
          backgroundColor: "#F0F4F8",
          height: 10,
          width: "100%",
          borderRadius: 30,
          mt: 1,
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: coloredBarPercentage(approvedComments, allComments),
            borderRadius: 30,
            bgcolor: reduxTheme.primary_colors[400],
          }}
        ></Box>
      </Box>
    </>
  );
};
